export const SchoolDataValidation = {
    school_attend: [
        { rule: "required", message: "Min salary is required" },
    ],
    program_taking: [
        { rule: "required", message: "Max salary is required" },
    ],
    start_date: [
        { rule: "required", message: "Start Date is required" },
    ],
    end_date: [
        { rule: "required", message: "End Date is required" },
    ]
}
